export enum ConfirmationModalIcon {
  SEND = 'send', // eslint-disable-line no-unused-vars
  INFO = 'info', // eslint-disable-line no-unused-vars
}

export type ConfirmationModalCreatorProps = {
  icon?: ConfirmationModalIcon;
  title: string;
  message?: string;
  footer?: string;
};

export const confirmationModalCreator = ({
  icon = ConfirmationModalIcon.SEND,
  title,
  message,
  footer,
}: ConfirmationModalCreatorProps): string => `
  <div class="modal-body modal-body-lg text-center">
    <div class="nk-modal">
      <em class="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-${icon} bg-primary-alt"></em>
      <h4 class="nk-modal-title">
        ${title.trim()}
      </h4>
      <div class="nk-modal-text mt-4">
        <p class="lead">
          ${message ? message.trim() : ''}
        </p>
        <p class="text-soft fs-14px">
          ${footer ? footer.trim() : ''}
        </p>
      </div>
    </div>
  </div>`;
